<template>
  <v-row>
    <v-col v-if="analytics && analytics.sections && hasPollEnded(analytics.status)" cols="12" sm="8">
      <v-alert v-if="analytics.sections.length == 0" outlined type="error" text>
        Alert!<br />
        No sections created.
      </v-alert>

      <v-row v-else>
        <v-col cols="12">
          <v-toolbar v-bind="toolbarProps">RESULTS</v-toolbar>
        </v-col>
        <v-col cols="12">
          <v-card flat class="pa-3 pt-0">
            <div v-for="(s, i) in analytics.sections" :key="i" :class="{ 'mt-8': i > 0 }">
              <span v-bind="labelProps2">
                &bullet; {{ s.description }} ({{ s.votes }} vote{{
                    s.votes > 1 ? "s" : ""
                }})
              </span>

              <v-list two-line class="pa-3">
                <v-list-item v-for="(o, j) in s.options" :key="j" class="pa-0 ma-0 mt-2 mb-4 d-flex align-start">
                  <v-avatar tile :size="o.sub_options.length > 0 ? 77 : 60" color="grey lighten-1" class="mr-3 rounded">
                    <v-img v-if="o.image_url" alt="avatar" :src="`${o.image_url}`"></v-img>
                    <v-icon v-else dark>
                      mdi-account
                    </v-icon>
                  </v-avatar>

                  <v-list-item-content>
                    <label v-bind="labelProps" class="mt-n2 mb-2"
                      :class="`${o.sub_options.length !== 0 && 'mt-n2'}`"><span v-bind="labelProps2">#{{ j + 1 }}</span>
                      {{ o.description }}
                      <span v-if="o.sub_options.length == 0" :class="`${getColor(i, j)}--text`">({{ o.votes }} vote{{
                          o.votes !== 1 ? "s" : ""
                      }})</span>
                    </label>

                    <v-progress-linear class="rounded-sm" :value="o.votes_percentage" height="22"
                      :color="getColor(i, j)" v-if="o.sub_options.length == 0">
                      <small>{{ o.votes_percentage || o.votes }}%</small>
                    </v-progress-linear>

                    <div v-else>
                      <v-row no-gutters>
                        <v-col cols="12" v-for="(so, k) in o.sub_options" :key="k"
                          :class="`${k < o.sub_options.length - 1 && 'mb-2'}`">
                          <v-progress-linear class="rounded-sm" :value="so.votes_percentage" :color="getColor(i, k)"
                            height="20">
                            <small>{{ so.description }}:
                              {{ so.votes_percentage || so.votes }}% ({{
                                  so.votes
                              }}
                              vote{{ so.votes !== 1 ? "s" : "" }})</small>
                          </v-progress-linear>
                        </v-col>
                      </v-row>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col v-if="analytics" cols="12" :sm="`${hasPollEnded(analytics.status) ? 4 : 12}`"
      :order="`${!hasPollEnded(analytics.status) && 'first'}`">
      <v-toolbar v-bind="toolbarProps">OVERVIEW</v-toolbar>

      <v-alert outlined type="info" text class="d-none d-sm-block d-md-block d-lg-block d-xl-block">
        Info!<br />
        {{ message }}
      </v-alert>
      <v-row class="my-4">
        <v-col cols="12" :sm="`${hasPollEnded(analytics.status) ? '12' : '4'}`" v-for="(k, i) in [
          'total_voters',
          'total_votes',
          'total_voted_percentage',
        ]" :key="i">
          <SimpleCard :baseValue="useNFormatter(analytics[k], i > 1)" :baseText="getTitle(k)" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { toSentenceCase, nFormatter, toolbarProps, labelProps, labelProps2 } from "@/helpers";
import SimpleCard from "@/components/SimpleCard.vue";
import { mapActions } from "vuex";

export default {
  components: { SimpleCard },

  data: () => ({
    loading: false,
    toolbarProps,
    labelProps,
    labelProps2
  }),

  computed: {
    analytics() {
      const { analytics } = this.$store.getters.getCollection("analytics");
      return analytics;
    },

    message() {
      const { message } = this.$store.getters.getCollection("analytics");
      return message ? message : "";
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    hasPollEnded(arg) {
      return new String(arg).toLowerCase() === "ended";
    },

    useNFormatter(num, percentage) {
      if (!num) return 0;
      else if (percentage) return `${num.toFixed(1) + "%"}`;
      else return nFormatter(num);
    },

    getTitle(str) {
      const arr = new String(str).split("_");
      const mapArr = arr.length > 2 ? arr.slice(-2, arr.length) : arr.slice();

      const capEachWord = mapArr.map((str) => {
        return toSentenceCase(str);
      });

      return capEachWord.join(" ");
    },

    getColor(secIndex, optIndex) {
      const currOptions =
        this.analytics.sections[secIndex].options.length == 1
          ? this.analytics.sections[secIndex].options[0].sub_options
          : this.analytics.sections[secIndex].options;

      // only one option
      if (currOptions.length == 1) return "success";

      if (optIndex == 0) {
        const firstPlace = currOptions[optIndex];
        const secondPlace = currOptions[optIndex + 1];

        // first percentage is greater than second percentage
        if (
          secondPlace &&
          firstPlace.votes_percentage !== 0 &&
          firstPlace.votes_percentage > secondPlace.votes_percentage
        ) {
          return "success";
        }
      }

      return "error";
    },
  },

  async mounted() {
    await this.makeFetch({
      method: "get",
      goTo: `/polls/${this.$route.params.id}`,
      way: "/analytics",
      stateVar: "analytics",
    }).catch(console.error);
  },
};
</script>
